<p-drawer
  [visible]="display"
  position="right"
  (onHide)="closeSidebarModel()"
  appendTo="body"
  class="sidebarWidth"
  [header]="heading"
  [dismissible]="false">
  <div class="mb-2 left-sidebar">
    <div>
      <div class="col-12 mb-4">
        <div class="has-float-label">
          <label class="form-label">Notes</label>
          <textarea
            jniAutoCompleteBlocker
            name="Notes"
            type="text"
            class="form-control w-100 large-textarea"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="notes"></textarea>
        </div>
      </div>
    </div>

    <div>
      <p-button label="save" [disabled]="!notes" (click)="saveNotes()" />

      <!-- <button
        class="btn btn-primary me-3 post"
        type="submit"
        [disabled]="!notes"
        (click)="saveNotes()">
        save
      </button> -->
    </div>
  </div>
</p-drawer>
